module.exports = __webpack_public_path__ + "static/media/pic7.8b7bed32.jpg";